import { Button, Group, Stack, Text, Title } from "@mantine/core";
import { IconArrowRight } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import "./AssignmentSupportCta.css";

export const assignmentSupportCtaContent = {
  title: "Need Help With an Assignment?",
  description:
    "Share your subject, brief, deadline, and marking criteria. SubjectBuddy will help you understand the task, plan your work, and improve your submission with subject-specific academic guidance.",
};

interface AssignmentSupportCtaProps {
  className?: string;
}

function AssignmentSupportCta({ className }: AssignmentSupportCtaProps) {
  const sectionClassName = ["assignment-support-cta", className]
    .filter(Boolean)
    .join(" ");

  return (
    <section className={sectionClassName}>
      <Stack gap="lg" align="center" ta="center">
        <Title order={2}>{assignmentSupportCtaContent.title}</Title>
        <Text c="dimmed" maw={760} className="assignment-support-cta-copy">
          {assignmentSupportCtaContent.description}
        </Text>
        <Group gap="md" justify="center">
          <Button
            component={Link}
            to="/contact"
            size="lg"
            radius="md"
            rightSection={<IconArrowRight size={18} />}
          >
            Get Help Now
          </Button>
          <Button
            component={Link}
            to="/assignment-help"
            size="lg"
            radius="md"
            variant="outline"
            color="green"
            rightSection={<IconArrowRight size={18} />}
          >
            Browse All Services
          </Button>
        </Group>
      </Stack>
    </section>
  );
}

export default AssignmentSupportCta;
